import { AmbientLight, DirectionalLight } from "three";

class Lighting {
	ambientLight = null;
	directionalLight = null;

	setup(scene, sharedLayer) {
		// Add lighting on shared layer (layer 0)
		this.ambientLight = new AmbientLight(0xffffff, 1);
		this.ambientLight.layers.set(sharedLayer);
		scene.add(this.ambientLight);

		this.directionalLight = new DirectionalLight(0xffffff, 1.5);
		this.directionalLight.position.set(0, 0, 1);
		this.directionalLight.layers.set(sharedLayer);
		scene.add(this.directionalLight);
	}
}

export default Lighting;

